import React from 'react';
import { Modal } from 'react-bootstrap';
import fbCompletePic from 'assets/images/backoffice/online-store/fb-setup-complete.png';
import googleCompletePic from 'assets/images/backoffice/online-store/google-setup-complete.png';
import classNames from 'classnames';
import { connect } from 'react-redux';
import styles from './CompleteSetupModal.css';

const channelSpecificText = {
  facebook: {
    icon: fbCompletePic,
    title: 'Your Facebook and Instagram Shop Has Been Created!',
    subText: () => {
      return (
        <span>
          Your shop is in the approval process.
          <br />
          The approval takes up to 4 weeks for Facebook, 1 week for Instagram.
        </span>
      );
    },
  },
  google: {
    icon: googleCompletePic,
    title: 'Your Setup is Complete and Under Review!',
    subText: () => {
      return (
        <span>
          Your products are in the approval process by Google. Please wait{' '}
          <strong>up to 5 days</strong> until your
          <br />
          products can be discovered via{' '}
          <strong>Google Shopping & Image!</strong>
        </span>
      );
    },
  },
};

class CompleteSetupModal extends React.Component {
  render() {
    const { shopDetail } = this.props.shop;
    if (!shopDetail) {
      return null;
    }

    const channel = shopDetail.channel.toLowerCase();

    return (
      <Modal
        onHide={this.props.onHide}
        backdrop="static"
        show
        dialogClassName={classNames(
          `modal-dialog`,
          styles.dialog,
          styles[channel]
        )}
      >
        <Modal.Body>
          <div>
            <div
              className={classNames(styles['image-dialog'], styles[channel])}
            >
              <img src={channelSpecificText[channel].icon} />
            </div>
            <div className={classNames(styles['text-dialog'], styles.primary)}>
              <h3> {channelSpecificText[channel].title}</h3>
            </div>
            <div
              className={classNames(styles['text-dialog'], styles.secondary)}
            >
              {channelSpecificText[channel].subText()}
            </div>
            <div className={`text-center`}>
              <button
                type="button"
                className={`${styles['main-btn-dialog']} btn btn-primary`}
                onClick={this.props.onHide}
              >
                Done
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    shop: state.onlineStore.shop,
  };
}

export default connect(mapStateToProps)(CompleteSetupModal);
